import { CornSchema } from '@eigtech/shared-corn';
import { z } from 'zod';
export const MeetingKeySchema = z.object({
    entityId: CornSchema,
    startTime: z.string().datetime(),
});
